<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and legend -->
      <b-card-title class="mb-50"> แสดงสรุปยอดขายตามประเภทสินค้า </b-card-title>
      <!--/ title and legend -->

      <!-- datepicker -->
      <!-- <div class="d-flex align-items-center">
        <feather-icon icon="CalendarIcon" size="16" />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range' }"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
      <!-- datepicker -->
    </b-card-header>

    <b-card-body>
      <vue-apex-charts
        type="bar"
        height="350"
        :options="barChart.chartOptions"
        :series="barChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import flatPickr from "vue-flatpickr-component";
import apexChatData from "./apexChartData";
import store from "@/store";

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    flatPickr,
    BCardTitle,
  },
  data() {
    return {
      apexChatData,
      rangePicker: ["2019-05-01", "2019-05-10"],
      barChart: {
        series: [{ data: [] }],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          colors: "#2b9bf4",
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: "30%",
              endingShape: "rounded",
            },
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },
    };
  },

  mounted() {
    this.getReportProductCategorySell();
  },
  methods: {
    getReportProductCategorySell() {
      store
        .dispatch("dashboard-seller/getReportProductCategorySell")
        .then(async (response) => {
          var datList = [];
          var cateList = [];
          await response.data.data.map((item, index) => {
            datList.push(Number(item.salesSummaryPriceProduct));

            cateList.push(String(item.categoryName) || "xxx");
          });

          this.barChart.chartOptions.xaxis.categories = cateList;

          this.barChart.series[0].data = datList;

          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
